<template>
  <generic-modal
    :title="$t('consulting room calendar')"
    ref="generic_modal"
    :is_wide="true"
  >
    <div class="form">calendar here</div>

    <!-- <pre>{{ attentions }}</pre> -->
    <div class="notification is-danger mt-5" v-if="error" v-html="error"></div>
    <template v-slot:footer>
      <!-- <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button
        class="button is-danger is-rounded"
        @click="remove"
        v-if="meta.uuid"
      >
        <span class="icon">
          <i class="fa fa-trash"></i>
        </span>
        <span>{{ $t("delete") }}</span>
      </button> -->
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("close") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  del,
  confirm_deletion_dialog,
  get,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
  format_date_time,
  format_currency,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericCalendar from "@/components/generic_calendar/Index.vue";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";
import moment from "moment";

export default {
  name: "AppointmentModal",
  components: {
    GenericModal,
    GenericCalendar,
    GenericDropdown,
  },
  data() {
    return {
      hospitalization_uuid: "",
      attention: {
        settings: {},
      },
      attentions: [],
      error: "",
    };
  },
  computed: {
    // is_form_invalid() {
    //   let v = this;
    //   return false;
    //   // return !v.meta.patient_id || !v.meta.start_date;
    // },
    total() {
      let v = this;
      if (v.attentions && v.attentions.length) {
        return v.attentions.reduce((acc, cur) => acc + Number(cur.price), 0);
      } else {
        return 0;
      }
    },
  },
  methods: {
    format_date_time,
    format_currency,
    refresh() {
      let v = this;
      get("/patient/hospitalization/attention", {
        uuid: v.hospitalization_uuid,
      })
        .then((attentions) => {
          v.attentions = attentions;
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal(consulting_room_uuid) {
      let v = this;
      v.set_initial_state();
      console.log("consulting_room_uuid", consulting_room_uuid);
      v.$refs.generic_modal.show_modal();

      // if (hospitalization_uuid) {
      //   v.hospitalization_uuid = hospitalization_uuid;
      //   // v.uuid = product_uuid;
      //   v.refresh();
      //   v.$refs.generic_modal.show_modal();
      // } else v.$refs.generic_modal.show_modal();
    },
    set_initial_state() {
      let v = this;
      v.error = "";
      // v.uuid = "";
    },
    set_product(product) {
      let v = this;
      if (product) v.attention.product_id = product.product_id;
    },
    add_attention() {
      let v = this;
      let data = {
        ...v.attention,
        hospitalization_uuid: v.hospitalization_uuid,
      };
      put("/patient/hospitalization/attention", data)
        .then((attention) => {
          v.set_initial_state();
          v.refresh();
          // v.$emit("refresh");
          // v.$refs.generic_modal.close_modal();
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
    delete_attention(attention) {
      let v = this;
      confirm_deletion_dialog(
        v.$t("are you sure to delete attention?"),
        v,
        () => {
          del("/patient/hospitalization/attention", {
            uuid: attention.uuid,
          })
            .then(() => {
              v.refresh();
            })
            .catch((error) => {
              v.error = generate_error_message_text(error);
            });
        }
      );
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
